module.exports = __webpack_public_path__ + "img/4-1.6186f207.png";